/* eslint-disable import/no-cycle */

import React, { lazy } from 'react';
import { componentLoader } from 'utils/componentLoader';

const LegalStaticPage = lazy(() => componentLoader(() => import(/* webpackChunkName: "LegalStaticPage" */ 'components/LegalStaticPage')));

export default ({ slug, pageTitle }) => () => (
  <LegalStaticPage slug={slug} pageTitle={pageTitle} />
);
